import { portalText } from "../../i18n/portal.js";
/**
 * A finished voice test's line (review #233) — the phone test's and the browser test's alike
 * (plan-004 WC-51, FR-BV-7, AC-BV-8): what is CHARGED, and the list price as a note when the free
 * minutes covered some or all of it — History's rule and words (`trialNoteOf`). It used to print the
 * list price as "billed" while the trial covered the whole call and nothing was charged.
 *
 * AMENDED 2026-10-12 (plan-017 WAPP-B, owner answers Q4, PQ-5 and PQ-14): tests are free. A test pinned after the
 * talk rate cutover comes back with nothing charged, so the line says its talk time and "Tests are free." — no
 * amount. Only a test from before the cutover, which really was charged, still names what it cost.
 *
 * Its own module (moved out of `voice-test-form.tsx`, which re-exports it) so the browser test can
 * use it without the two components importing each other.
 */
import { trialNoteOf } from "../../api/conversation-view.js";
import type { TestCallView } from "../../api/gateway.js";
import { formatDuration, formatMoney } from "../../money.js";

export function endedLineOf(view: TestCallView): string {
  const length = portalText("operations", "ended_after_value_54a01ae9", { v0: String(formatDuration(view.billedSeconds)) });
  const free = view.billedAmount.amountMinor === 0 && (view.chargedAmount === null || view.chargedAmount.amountMinor === 0);
  if (free) return `${length} · ${portalText("core", "talk_rate.tests_are_free")}`;
  if (view.chargedSeconds === null || view.chargedAmount === null) {
    return portalText("operations", "value_value_at_list_price_8e8bd9c7", { v0: String(length), v1: String(formatMoney(view.billedAmount)) });
  }
  const note = trialNoteOf(view.billedSeconds, view.chargedSeconds, view.billedAmount);
  const line = portalText("operations", "value_value_charged_82988c2a", { v0: String(length), v1: String(formatMoney(view.chargedAmount)) });
  return note === null ? line : `${line} · ${note}`;
}
